import $ from 'jquery';

$(function () {
    const $app = $('#retirement-calculator-app');
    if (!$app.length) return;

    // Load available presets
    let presets = [];
    try {
        const presetsRaw = $('#retirement-currency-presets').text();
        if (presetsRaw) {
            presets = JSON.parse(presetsRaw);
        }
    } catch (e) {
        console.error('Error parsing retirement presets:', e);
    }

    let activeCurrency = $app.data('selected-currency') || 'UAH';
    let currentPreset = presets.find(p => p.Code === activeCurrency) || presets[0] || {
        Code: 'UAH',
        Symbol: '₴',
        DefaultMonthlyIncome: 35000,
        DefaultSavings: 100000,
        DefaultAccumReturn: 12.0,
        DefaultRetireReturn: 9.0,
        DefaultInflation: 7.5,
        DefaultStatePension: 5000,
        IncomeChips: [20000, 35000, 50000, 75000, 100000]
    };

    // DOM Elements
    const $currSymbols = $('.ret-curr-symbol');
    const $currTabs = $('.ret-currency-tab');
    const $activeCustomCurrency = $('#ret-active-custom-currency');
    const $moreCurrenciesBtn = $('#ret-more-currencies-dropdown');

    const $currentAgeSlider = $('#ret-current-age-slider');
    const $currentAgeDisplay = $('#ret-current-age-display');
    const $targetAgeSlider = $('#ret-target-age-slider');
    const $targetAgeDisplay = $('#ret-target-age-display');
    const $yearsToSave = $('#ret-years-to-save');

    const $desiredIncomeInput = $('#ret-desired-income-input');
    const $incomeChipsWrapper = $('#ret-income-chips-wrapper');
    const $currentSavingsInput = $('#ret-current-savings-input');

    const $accumReturnSlider = $('#ret-accum-return-slider');
    const $accumReturnDisplay = $('#ret-accum-return-display');

    // Advanced Elements
    const $lifeExpectancySlider = $('#ret-life-expectancy-slider');
    const $lifeExpectancyDisplay = $('#ret-life-expectancy-display');
    const $yearsInRetirement = $('#ret-years-in-retirement');
    const $retireReturnSlider = $('#ret-retire-return-slider');
    const $retireReturnDisplay = $('#ret-retire-return-display');
    const $inflationSlider = $('#ret-inflation-slider');
    const $inflationDisplay = $('#ret-inflation-display');
    const $statePensionInput = $('#ret-state-pension-input');
    const $strategyCards = $('.ret-strategy-card');
    const $advancedCollapse = $('#ret-advanced-collapse');
    const $advancedChevron = $('#ret-advanced-chevron');

    // Result Outputs
    const $statMonthlySave = $('#ret-stat-monthly-save');
    const $statTargetCapital = $('#ret-stat-target-capital');
    const $statExistingGrowth = $('#ret-stat-existing-growth');
    const $statContributions = $('#ret-stat-contributions');
    const $statInterest = $('#ret-stat-interest');
    const $interestSharePct = $('#ret-interest-share-pct');
    const $progContributions = $('#ret-prog-contributions');
    const $progInterest = $('#ret-prog-interest');

    const $heroCompounding = $('#ret-hero-compounding-power');
    const $humanCapitalPct = $('#ret-human-capital-pct');
    const $financialCapitalPct = $('#ret-financial-capital-pct');
    const $progHumanCapital = $('#ret-prog-human-capital');
    const $progFinancialCapital = $('#ret-prog-financial-capital');
    const $mertonInsightText = $('#ret-merton-insight-text');

    const $whatifDelayDesc = $('#ret-whatif-delay-desc');
    const $whatifExtraDesc = $('#ret-whatif-extra-desc');

    const $glideAge = $('#ret-glide-age');
    const $glideStocks = $('#ret-glide-stocks');
    const $glideBonds = $('#ret-glide-bonds');
    const $glideDeposits = $('#ret-glide-deposits');
    const $glideStocksVal = $('#ret-glide-stocks-val');
    const $glideBondsVal = $('#ret-glide-bonds-val');
    const $glideDepositsVal = $('#ret-glide-deposits-val');

    // Localized text strings from data attributes
    const textYearsShort = $app.data('text-years-short') || 'р.';
    const textYears = $app.data('text-years') || 'р.';
    const textMoreCurrencies = $app.data('text-more-currencies') || 'Більше валют';
    const textMoreShort = $app.data('text-more-short') || 'Ще...';
    const textWhatifDelay = $app.data('text-whatif-delay') || 'Якщо вийти на пенсію у <strong>{0} {1}</strong>, щомісячний внесок зменшиться на <strong class="text-success">{2}%</strong> (до {3} {4}).';
    const textWhatifExtra = $app.data('text-whatif-extra') || 'Внесок на 10% більше (+{0} {1}) дозволить сформувати додаткову подушку безпеки або вийти на пенсію на 1-2 роки раніше.';

    function formatTemplate(tpl, ...args) {
        if (!tpl) return '';
        return tpl.replace(/\{(\d+)\}/g, (match, idx) => {
            return typeof args[idx] !== 'undefined' ? args[idx] : match;
        });
    }

    function formatNumber(val, decimals = 0) {
        if (isNaN(val) || !isFinite(val)) return '0';
        return val.toLocaleString('uk-UA', {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        });
    }

    function syncCurrencyUI(preset) {
        currentPreset = preset;
        activeCurrency = preset.Code;
        $currSymbols.text(preset.Symbol);

        // Update active tab styles
        $currTabs.removeClass('active');
        $(`.ret-currency-tab[data-currency="${preset.Code}"]`).addClass('active');

        // Update dropdown button label
        if (!preset.IsQuickTab) {
            $activeCustomCurrency.html(`<strong>${preset.Symbol} ${preset.Code}</strong>`);
            $moreCurrenciesBtn.addClass('active');
        } else {
            $activeCustomCurrency.html(`<span class="d-none d-sm-inline">${textMoreCurrencies}</span><span class="d-sm-none">${textMoreShort}</span>`);
            $moreCurrenciesBtn.removeClass('active');
        }

        // Render quick chips for this currency
        if (preset.IncomeChips && preset.IncomeChips.length) {
            let chipsHtml = '';
            preset.IncomeChips.forEach(chip => {
                chipsHtml += `<button type="button" class="btn btn-sm btn-outline-light text-body border font-size-12 px-2 py-1 ret-income-chip" data-val="${chip}">
                    ${chip.toLocaleString('uk-UA')} <span class="ret-curr-symbol">${preset.Symbol}</span>
                </button>`;
            });
            $incomeChipsWrapper.html(chipsHtml);
        }
    }

    function recalculate() {
        // Read inputs
        let curAge = parseInt($currentAgeSlider.val(), 10) || 30;
        let retAge = parseInt($targetAgeSlider.val(), 10) || 60;
        let lifeExp = parseInt($lifeExpectancySlider.val(), 10) || 85;

        // Constraints enforcement
        if (retAge <= curAge) {
            retAge = curAge + 1;
            $targetAgeSlider.val(retAge);
        }
        if (lifeExp <= retAge) {
            lifeExp = retAge + 1;
            $lifeExpectancySlider.val(lifeExp);
        }

        $currentAgeDisplay.text(curAge);
        $targetAgeDisplay.text(retAge);
        $lifeExpectancyDisplay.text(lifeExp);

        const yearsToSave = retAge - curAge;
        const yearsInRetirement = lifeExp - retAge;
        $yearsToSave.text(`${yearsToSave} ${textYears}`);
        $yearsInRetirement.text(`${yearsInRetirement} ${textYears}`);
        $glideAge.text(curAge);

        const desiredIncome = parseFloat($desiredIncomeInput.val()) || 0;
        const currentSavings = parseFloat($currentSavingsInput.val()) || 0;
        const statePension = parseFloat($statePensionInput.val()) || 0;

        const accumNomReturn = (parseFloat($accumReturnSlider.val()) || 12.0) / 100;
        const retireNomReturn = (parseFloat($retireReturnSlider.val()) || 9.0) / 100;
        const inflation = (parseFloat($inflationSlider.val()) || 7.5) / 100;

        $accumReturnDisplay.text((accumNomReturn * 100).toFixed(1));
        $retireReturnDisplay.text((retireNomReturn * 100).toFixed(1));
        $inflationDisplay.text((inflation * 100).toFixed(1));

        const strategy = $('input[name="retCapitalStrategy"]:checked').val() || 'annuity';

        // 1. Net private retirement income needed in real terms (today's prices)
        const netDesiredMonthly = Math.max(0, desiredIncome - statePension);
        const netDesiredAnnual = netDesiredMonthly * 12;

        // 2. Real returns via Fisher equation: r* = (1 + r) / (1 + i) - 1
        let realAccumReturn = (1 + accumNomReturn) / (1 + inflation) - 1;
        let realRetireReturn = (1 + retireNomReturn) / (1 + inflation) - 1;

        // Prevent zero/negative real return division singularity
        if (realAccumReturn <= 0.001) realAccumReturn = 0.001;
        if (realRetireReturn <= 0.001) realRetireReturn = 0.001;

        // 3. Target Capital needed at Retirement Date (W_req)
        let targetCapital = 0;
        if (strategy === 'perpetuity') {
            // Capital Preservation: Live off real yield only
            targetCapital = netDesiredAnnual / realRetireReturn;
        } else {
            // Annuity: Consume principal + real return over retirement years
            const annuityFactor = (1 - Math.pow(1 + realRetireReturn, -yearsInRetirement)) / realRetireReturn;
            targetCapital = netDesiredAnnual * annuityFactor;
        }

        // 4. Future real value of existing savings at retirement date
        const existingGrowth = currentSavings * Math.pow(1 + realAccumReturn, yearsToSave);

        // 5. Gap to fund via monthly contributions
        const capitalGap = Math.max(0, targetCapital - existingGrowth);

        // 6. Required monthly savings today
        const totalMonths = yearsToSave * 12;
        const monthlyRealReturn = realAccumReturn / 12;
        let requiredMonthly = 0;

        if (totalMonths > 0 && capitalGap > 0) {
            const compoundFactor = Math.pow(1 + monthlyRealReturn, totalMonths) - 1;
            requiredMonthly = (capitalGap * monthlyRealReturn) / compoundFactor;
        }

        // 7. Breakdown of total self-contributions vs compounding interest
        const totalContributions = currentSavings + (requiredMonthly * totalMonths);
        const totalInterest = Math.max(0, targetCapital - totalContributions);
        const interestPct = targetCapital > 0 ? Math.min(99, Math.round((totalInterest / targetCapital) * 100)) : 0;
        const contributionsPct = 100 - interestPct;

        // Render Primary Stat Cards
        $statMonthlySave.text(formatNumber(Math.round(requiredMonthly)));
        $statTargetCapital.text(formatNumber(Math.round(targetCapital)));
        $statExistingGrowth.text(formatNumber(Math.round(existingGrowth)));

        $statContributions.text(formatNumber(Math.round(totalContributions)));
        $statInterest.text(formatNumber(Math.round(totalInterest)));
        $interestSharePct.text(`${interestPct}%`);

        $progContributions.css('width', `${contributionsPct}%`);
        $progInterest.css('width', `${interestPct}%`);

        const compoundingMultiplier = totalContributions > 0 ? (targetCapital / totalContributions).toFixed(1) : '1.0';
        $heroCompounding.text(`${compoundingMultiplier}x`);

        // 8. Merton Human Capital vs Financial Capital Ratio
        // Human capital is proportional to working years remaining
        const maxWorkSpan = Math.max(1, retAge - 18);
        const humanCapitalRatio = Math.max(10, Math.min(90, Math.round((yearsToSave / maxWorkSpan) * 100)));
        const financialCapitalRatio = 100 - humanCapitalRatio;

        $humanCapitalPct.text(`${humanCapitalRatio}%`);
        $financialCapitalPct.text(`${financialCapitalRatio}%`);
        $progHumanCapital.css('width', `${humanCapitalRatio}%`);
        $progFinancialCapital.css('width', `${financialCapitalRatio}%`);

        // 9. Merton Asset Allocation Glidepath based on Age
        let stocksPct = 70;
        let bondsPct = 25;
        let depositsPct = 5;

        if (curAge <= 35) {
            stocksPct = 75;
            bondsPct = 20;
            depositsPct = 5;
        } else if (curAge <= 48) {
            stocksPct = 55;
            bondsPct = 35;
            depositsPct = 10;
        } else if (curAge <= 58) {
            stocksPct = 35;
            bondsPct = 50;
            depositsPct = 15;
        } else {
            stocksPct = 20;
            bondsPct = 60;
            depositsPct = 20;
        }

        $glideStocks.css('width', `${stocksPct}%`);
        $glideBonds.css('width', `${bondsPct}%`);
        $glideDeposits.css('width', `${depositsPct}%`);
        $glideStocksVal.text(`${stocksPct}%`);
        $glideBondsVal.text(`${bondsPct}%`);
        $glideDepositsVal.text(`${depositsPct}%`);

        // 10. What-If Scenarios
        // Scenario A: Retiring 3 years later
        const delayYears = 3;
        const delayedYearsToSave = yearsToSave + delayYears;
        const delayedMonths = delayedYearsToSave * 12;
        let delayedTarget = targetCapital;
        if (strategy === 'annuity') {
            const delayedRetYears = Math.max(1, yearsInRetirement - delayYears);
            const delayedAnnuityFactor = (1 - Math.pow(1 + realRetireReturn, -delayedRetYears)) / realRetireReturn;
            delayedTarget = netDesiredAnnual * delayedAnnuityFactor;
        }
        const delayedExistingGrowth = currentSavings * Math.pow(1 + realAccumReturn, delayedYearsToSave);
        const delayedGap = Math.max(0, delayedTarget - delayedExistingGrowth);
        const delayedCompound = Math.pow(1 + monthlyRealReturn, delayedMonths) - 1;
        const delayedMonthly = delayedGap > 0 ? (delayedGap * monthlyRealReturn) / delayedCompound : 0;
        const savingsDropPct = requiredMonthly > 0 ? Math.round(((requiredMonthly - delayedMonthly) / requiredMonthly) * 100) : 0;

        const delayText = formatTemplate(
            textWhatifDelay,
            retAge + delayYears,
            textYearsShort,
            Math.max(1, savingsDropPct),
            formatNumber(Math.round(delayedMonthly)),
            currentPreset.Symbol
        );
        $whatifDelayDesc.html(delayText);

        // Scenario B: Saving 10% more
        const extraText = formatTemplate(
            textWhatifExtra,
            formatNumber(Math.round(requiredMonthly * 0.1)),
            currentPreset.Symbol
        );
        $whatifExtraDesc.html(extraText);
    }

    // Event Handlers
    $(document).on('click', '.ret-currency-tab', function (e) {
        e.preventDefault();
        const code = $(this).data('currency');
        const preset = presets.find(p => p.Code === code);
        if (preset) {
            syncCurrencyUI(preset);
            $desiredIncomeInput.val(preset.DefaultMonthlyIncome);
            $currentSavingsInput.val(preset.DefaultSavings);
            $accumReturnSlider.val(preset.DefaultAccumReturn);
            $retireReturnSlider.val(preset.DefaultRetireReturn);
            $inflationSlider.val(preset.DefaultInflation);
            $statePensionInput.val(preset.DefaultStatePension);
            recalculate();
        }
    });

    $(document).on('click', '.ret-income-chip', function (e) {
        e.preventDefault();
        const val = $(this).data('val');
        if (val) {
            $desiredIncomeInput.val(val);
            recalculate();
        }
    });

    $('input[name="retCapitalStrategy"]').on('change', function () {
        $strategyCards.removeClass('border-primary');
        $(this).closest('.ret-strategy-card').addClass('border-primary');
        recalculate();
    });

    $('.ret-strategy-card').on('click', function (e) {
        if ($(e.target).is('input[type="radio"]') || $(e.target).is('label')) return;
        const $radio = $(this).find('input[type="radio"]');
        if (!$radio.prop('checked')) {
            $radio.prop('checked', true).trigger('change');
        }
    });

    $(document).on('click', '.js-scroll-to-merton', function (e) {
        e.preventDefault();
        const targetSelector = $(this).attr('href') || $(this).data('target');
        const $target = $(targetSelector);
        if ($target.length) {
            $('html, body').animate({
                scrollTop: $target.offset().top - 80
            }, 500);
            $target.addClass('border-primary shadow').css('transition', 'all 0.4s ease');
            setTimeout(function () {
                $target.removeClass('border-primary shadow');
            }, 2000);
        }
    });

    // Inputs & Sliders Change
    $currentAgeSlider.on('input change', recalculate);
    $targetAgeSlider.on('input change', recalculate);
    $lifeExpectancySlider.on('input change', recalculate);
    $accumReturnSlider.on('input change', recalculate);
    $retireReturnSlider.on('input change', recalculate);
    $inflationSlider.on('input change', recalculate);

    $desiredIncomeInput.on('input change', recalculate);
    $currentSavingsInput.on('input change', recalculate);
    $statePensionInput.on('input change', recalculate);

    // Advanced Chevron Animation
    $advancedCollapse.on('show.bs.collapse', function () {
        $advancedChevron.removeClass('bx-chevron-down').addClass('bx-chevron-up');
    }).on('hide.bs.collapse', function () {
        $advancedChevron.removeClass('bx-chevron-up').addClass('bx-chevron-down');
    });

    // Initial calculation on page load (without auto-scroll!)
    syncCurrencyUI(currentPreset);
    recalculate();

    // Initialize tooltips
    if (typeof window.fn_apply_global_tooltips === 'function') {
        window.fn_apply_global_tooltips();
    } else if (window.bootstrap && typeof window.bootstrap.Tooltip === 'function') {
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new window.bootstrap.Tooltip(tooltipTriggerEl, { container: 'body' });
        });
    }
});

